export const handleLoadMoreLabel = (params) => {

	const {
		page, limit, total, data, text,
	} = params;

	const rangeFirst = (page * limit + 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
	const rangeEnd = data?.length + limit > total
		? total?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
		: (data?.length + limit).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
	const totalData = total?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

	return `Load ${rangeFirst} - ${rangeEnd} of ${totalData} ${text}`;

};

export default handleLoadMoreLabel;
